import '../augmentations';

import { CssBaseline, type Theme, ThemeProvider } from '@mui/material';
import { ReactNode } from 'react';

import { darkTheme, lightTheme } from '../theme';
import { UIDateProvider } from '../UIDateProvider/UIDateProvider';

type Props = {
  mode?: 'light' | 'dark';
  theme?: Theme;
  disableBaseline?: boolean;
  children: ReactNode;
};

/**
 * Applies the design system theme and the French date context of the design system pickers.
 * The date context is provided here because the app may resolve its own copy of
 * `@mui/x-date-pickers`, whose `LocalizationProvider` the design system pickers cannot read.
 */
export function UIThemeProvider(props: Props) {
  const resolvedTheme = props.theme ?? (props.mode === 'dark' ? darkTheme : lightTheme);

  return (
    <ThemeProvider theme={resolvedTheme}>
      {!props.disableBaseline && <CssBaseline />}
      <UIDateProvider>{props.children}</UIDateProvider>
    </ThemeProvider>
  );
}

export type { Props as UIThemeProviderProps };
